var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getAccessToken, getSession } from "../utils/auth0";
import { buildIdentityUrl } from "../utils/identity-url";
/**
 * Safely parse JSON response, falling back to text if JSON parsing fails
 */
function safeJson(response) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return (yield response.clone().json());
        }
        catch (_a) {
            return response.text();
        }
    });
}
/**
 * Handler for fetching app settings from the identity service.
 * This endpoint acts as a secure server-side proxy to the identity service.
 *
 * @param req - The Next.js API request
 * @param res - The Next.js API response
 */
export function handleIdentitySettings(req, res) {
    return __awaiter(this, void 0, void 0, function* () {
        if (req.method !== "GET") {
            res.status(405).json({ message: "Method not allowed" });
            return;
        }
        try {
            const session = yield getSession(req, res);
            if (!(session === null || session === void 0 ? void 0 : session.user)) {
                res.status(401).json({ message: "Not authenticated" });
                return;
            }
            const { accessToken } = yield getAccessToken(req, res);
            // Call the identity service to get app settings
            // Uses buildIdentityUrl to dynamically determine the correct environment
            const identityUrl = buildIdentityUrl("/v1/app-settings/ecoPortalApps");
            const upstream = yield fetch(identityUrl, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
                cache: "no-store",
            });
            if (!upstream.ok) {
                const errorBody = yield safeJson(upstream);
                // eslint-disable-next-line no-console
                console.error("[identitySettings] Identity service error:", {
                    status: upstream.status,
                    body: errorBody,
                });
                res.status(upstream.status).json({
                    message: "Failed to fetch settings from identity service",
                    upstreamStatus: upstream.status,
                    error: errorBody,
                });
                return;
            }
            const settingsData = yield upstream.json();
            // Set cache headers to prevent stale data
            res.setHeader("Cache-Control", "no-store");
            res.status(200).json(settingsData);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error("Settings endpoint error:", error);
            res.status(500).json({
                message: "Internal server error",
                error: error instanceof Error ? error.message : "Unknown error",
            });
        }
    });
}
